import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

export const PageWrapper = styled(Box)(({ theme }) => `
  padding: 32px 40px;
  background: #F9FAFB;
  min-height: calc(100vh - ${theme.header.height});

  @media (max-width: ${theme.breakpoints.values.lg}px) {
    padding: 24px 20px;
  }
`);

export const Breadcrumbs = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  color: #616161;
`);

export const BreadcrumbLink = styled(Link)(() => `
  color: #616161;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: #212121;
  }
`);

export const BreadcrumbSeparator = styled('span')(() => `
  color: #9E9E9E;
`);

export const BreadcrumbCurrent = styled('span')(() => `
  color: #212121;
  font-weight: 600;
`);

export const TopicHeader = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`);

export const TopicIcon = styled('div')(() => `
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #EB0A1E;

  img, svg {
    width: 32px;
    height: 32px;
  }
`);

export const TopicTitle = styled('h1')(() => `
  font-family: 'Toyota', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #101828;
  margin: 0;
`);

export const TopicDescription = styled('p')(() => `
  font-size: 15px;
  color: #616161;
  margin: 0 0 20px 0;
  line-height: 1.5;
`);

export const SearchWrapper = styled(Box)(() => `
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  max-width: 700px;
`);

export const SearchIcon = styled('img')(() => `
  position: absolute;
  left: 16px;
  width: 18px;
  height: 18px;
  pointer-events: none;
  filter: brightness(0) saturate(100%) invert(40%);
`);

export const SearchInput = styled('input')(() => `
  width: 100%;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 12px 16px 12px 44px;
  font-size: 14px;
  color: #424242;
  background: white;
  outline: none;

  &::placeholder {
    color: #9E9E9E;
  }

  &:focus {
    border-color: #EB0A1E;
  }
`);

export const ContentLayout = styled(Box)(({ theme }) => `
  display: flex;
  align-items: flex-start;
  gap: 24px;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;
  }
`);

export const MainContent = styled(Box)(({ theme }) => `
  flex: 1;
  min-width: 0;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    width: 100%;
  }
`);

export const Sidebar = styled(Box)(({ theme }) => `
  width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: sticky;
  top: calc(${theme.header.height} + 24px);
  align-self: flex-start;
  height: calc(100vh - ${theme.header.height} - 110px);
  overflow: hidden;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    width: 100%;
    position: static;
    height: auto;
    overflow: visible;
  }
`);

export const DocCount = styled('div')(() => `
  font-size: 14px;
  color: #616161;
  margin-bottom: 16px;
`);

export const DocumentCard = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px;
  background: white;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: box-shadow 0.2s;

  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
`);

export const DocIconWrapper = styled('div')(() => `
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #FFEEEF;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`);

export const DocContent = styled(Box)(() => `
  flex: 1;
  min-width: 0;
`);

export const DocTitle = styled('h3')(() => `
  font-size: 16px;
  font-weight: 600;
  color: #101828;
  margin: 0 0 4px 0;
`);

export const DocDescription = styled('p')(() => `
  font-size: 14px;
  color: #616161;
  margin: 0 0 10px 0;
  line-height: 1.4;
`);

export const DocTags = styled(Box)(() => `
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`);

export const DocTag = styled('span')(() => `
  background: #F3F4F6;
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #344054;
`);

export const DocMeta = styled(Box)(() => `
  text-align: right;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`);

export const DocType = styled('span')(() => `
  font-size: 13px;
  font-weight: 600;
  color: #344054;
`);

export const DocDate = styled('span')(() => `
  font-size: 12px;
  color: #9E9E9E;
  white-space: nowrap;
`);

export const DocArrow = styled('span')(() => `
  font-size: 18px;
  color: #9E9E9E;
  margin-top: 4px;
`);

export const SidebarCard = styled(Box)(() => `
  background: white;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 16px;
  flex-shrink: 0;
`);

export const PopularDocsCard = styled(Box)(() => `
  background: white;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`);

export const PopularDocsList = styled(Box)(() => `
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`);

export const AboutTopicImage = styled('img')(() => `
  width: 60px;
  height: auto;
  float: right;
  margin-left: 8px;
`);

export const AboutTopicTitle = styled('h3')(() => `
  font-size: 15px;
  font-weight: 700;
  color: #101828;
  margin: 0 0 6px 0;
`);

export const AboutTopicDescription = styled('p')(() => `
  font-size: 13px;
  color: #616161;
  margin: 0 0 12px 0;
  line-height: 1.4;
`);

export const AboutTopicStats = styled(Box)(() => `
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 10px 14px;
  clear: both;
`);

export const AboutTopicStatsIcon = styled('div')(() => `
  width: 28px;
  height: 28px;
  background: #FFEEEF;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`);

export const AboutTopicStatsCount = styled('div')(() => `
  font-size: 18px;
  font-weight: 700;
  color: #101828;
`);

export const AboutTopicStatsLabel = styled('div')(() => `
  font-size: 13px;
  color: #616161;
`);

export const PopularDocItem = styled(Box)(() => `
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;

  &:last-child {
    border-bottom: none;
  }
`);

export const PopularDocIcon = styled('div')(() => `
  width: 22px;
  height: 22px;
  background: #FFEEEF;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
`);

export const PopularDocTitle = styled('div')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #344054;
`);

export const PopularDocDate = styled('div')(() => `
  font-size: 12px;
  color: #9E9E9E;
  margin-top: 2px;
`);

export const NeedHelpCard = styled(Box)(() => `
  background: white;
  border: 1px solid #E0E0E0;
  border-radius: 8px;
  padding: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 14px;
`);

export const NeedHelpIcon = styled('div')(() => `
  width: 44px;
  height: 44px;
  background: #FFEEEF;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`);

export const NeedHelpContent = styled(Box)(() => `
  flex: 1;
`);

export const NeedHelpTitle = styled('div')(() => `
  font-size: 15px;
  font-weight: 700;
  color: #101828;
  margin-bottom: 2px;
`);

export const NeedHelpLink = styled('a')(() => `
  font-size: 14px;
  font-weight: 600;
  color: #EB0A1E;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    text-decoration: underline;
  }
`);
